/** Lao text for the booking chat: the guest assistant and Booking engine → Chat assistant. */
export const laoHotelBookingChat: Record<string, string> = {
  'First message choices': 'ຕົວເລືອກໃນຂໍ້ຄວາມທຳອິດ',
  'Use default choices, create your own, or hide them. Guests can always type a message.':
    'ໃຊ້ຕົວເລືອກເລີ່ມຕົ້ນ, ສ້າງເອງ ຫຼື ເຊື່ອງ. ແຂກຍັງສາມາດພິມຂໍ້ຄວາມໄດ້.',
  'Default choices in the guest’s language': 'ຕົວເລືອກເລີ່ມຕົ້ນຕາມພາສາຂອງແຂກ',
  'Custom choices': 'ຕົວເລືອກທີ່ກຳນົດເອງ',
  'Button label': 'ຊື່ປຸ່ມ',
  'Message sent when clicked': 'ຂໍ້ຄວາມທີ່ສົ່ງເມື່ອກົດ',
  'Move choice up': 'ຍ້າຍຕົວເລືອກຂຶ້ນ',
  'Remove choice': 'ລຶບຕົວເລືອກ',
  'Add choice': 'ເພີ່ມຕົວເລືອກ',
  'Up to 6 choices. Remove all choices to hide the buttons. Custom text is shown as written.':
    'ສູງສຸດ 6 ຕົວເລືອກ. ລຶບທັງໝົດເພື່ອເຊື່ອງປຸ່ມ. ຂໍ້ຄວາມທີ່ກຳນົດເອງຈະສະແດງຕາມທີ່ຂຽນ.',
  // Guest assistant
  'Welcome! I’d be happy to help with rooms, travel dates, or questions about your stay.':
    'ສະບາຍດີ! ຍິນດີຊ່ວຍທ່ານກ່ຽວກັບຫ້ອງພັກ, ວັນເດີນທາງ ຫຼື ຄຳຖາມກ່ຽວກັບການພັກຂອງທ່ານ.',
  'Chat with us': 'ແຊັດກັບພວກເຮົາ',
  'Questions? I can check rooms and prices instantly.':
    'ມີຄຳຖາມບໍ? ຂ້ອຍກວດຫ້ອງ ແລະ ລາຄາໃຫ້ໄດ້ທັນທີ.',
  'Hi! I can check live availability and prices, or answer questions about your stay.':
    'ສະບາຍດີ! ຂ້ອຍສາມາດກວດຫ້ອງຫວ່າງ ແລະ ລາຄາໃຫ້ທັນທີ ຫຼື ຕອບຄຳຖາມກ່ຽວກັບການພັກຂອງທ່ານ.',
  'Booking assistant': 'ຜູ້ຊ່ວຍຈອງຫ້ອງ',
  'Instant answers': 'ຕອບທັນທີ',
  'New conversation': 'ເລີ່ມການສົນທະນາໃໝ່',
  'Close chat': 'ປິດແຊັດ',
  Conversation: 'ການສົນທະນາ',
  'Typing…': 'ກຳລັງພິມ…',
  'Check availability': 'ກວດຫ້ອງຫວ່າງ',
  'Check-in time': 'ເວລາເຊັກອິນ',
  'Extras & services': 'ບໍລິການເສີມ',
  'Talk to staff': 'ລົມກັບພະນັກງານ',
  'Where are you?': 'ທີ່ຕັ້ງຢູ່ໃສ',
  'AI-generated answer · please confirm details with us':
    'ຄຳຕອບຈາກ AI · ກະລຸນາຢືນຢັນລາຍລະອຽດກັບພວກເຮົາ',
  'Great choice! Your room and dates are filled in on the booking form. Complete your details there to book.':
    'ເລືອກໄດ້ດີ! ຫ້ອງ ແລະ ວັນທີຖືກໃສ່ໃນແບບຟອມຈອງແລ້ວ. ກະລຸນາໃສ່ຂໍ້ມູນຂອງທ່ານເພື່ອຈອງ.',
  'Was this helpful?': 'ຄຳຕອບນີ້ມີປະໂຫຍດບໍ?',
  Helpful: 'ມີປະໂຫຍດ',
  'Not helpful': 'ບໍ່ມີປະໂຫຍດ',
  'Thanks for the feedback': 'ຂອບໃຈສຳລັບຄຳຕິຊົມ',
  Suggestions: 'ຄຳແນະນຳ',
  'Ask about rooms, dates or the hotel…': 'ຖາມກ່ຽວກັບຫ້ອງ, ວັນທີ ຫຼື ໂຮງແຮມ…',
  Message: 'ຂໍ້ຄວາມ',
  Stop: 'ຢຸດ',
  Send: 'ສົ່ງ',
  'Live prices from our booking system. Never share card or passport details in chat.':
    'ລາຄາອັບເດດຈາກລະບົບຈອງໂດຍກົງ. ຫ້າມສົ່ງເລກບັດ ຫຼື ໜັງສືຜ່ານແດນໃນແຊັດ.',
  'See all rooms and rates': 'ເບິ່ງຫ້ອງ ແລະ ລາຄາທັງໝົດ',
  Call: 'ໂທ',
  Map: 'ແຜນທີ່',
  'Verified answer from': 'ຄຳຕອບທີ່ຢືນຢັນໂດຍ',
  'Show available rooms': 'ສະແດງຫ້ອງຫວ່າງ',
  'Stopped. Send again when you are ready.': 'ຢຸດແລ້ວ. ສົ່ງອີກຄັ້ງເມື່ອທ່ານພ້ອມ.',
  'The assistant is unavailable. Please try again.': 'ຜູ້ຊ່ວຍບໍ່ພ້ອມໃຊ້ງານ. ກະລຸນາລອງໃໝ່.',
  'Chat is not available': 'ແຊັດບໍ່ພ້ອມໃຊ້ງານ',
  'Type a message': 'ພິມຂໍ້ຄວາມ',
  adult: 'ຜູ້ໃຫຍ່',
  adults: 'ຜູ້ໃຫຍ່',
  child: 'ເດັກນ້ອຍ',
  children: 'ເດັກນ້ອຍ',
  'more rate': 'ລາຄາອື່ນ',
  'more rates': 'ລາຄາອື່ນ',
  'That room is no longer available for these dates. Here is what is available now.':
    'ຫ້ອງນັ້ນບໍ່ຫວ່າງແລ້ວໃນວັນທີນີ້. ນີ້ແມ່ນຫ້ອງທີ່ຫວ່າງໃນຕອນນີ້.',

  // Booking engine → Chat assistant
  'Chat assistant': 'ຜູ້ຊ່ວຍແຊັດ',
  'Answer guests instantly on your booking page, in Lao, Thai, English and Chinese. Availability and prices come live from your rates; bookings go through your booking engine.':
    'ຕອບແຂກທັນທີໃນໜ້າຈອງຂອງທ່ານ ເປັນພາສາລາວ, ໄທ, ອັງກິດ ແລະ ຈີນ. ຫ້ອງຫວ່າງ ແລະ ລາຄາມາຈາກລາຄາຂອງທ່ານໂດຍກົງ; ການຈອງຜ່ານລະບົບຈອງອອນລາຍຂອງທ່ານ.',
  'Show the chat on the booking page': 'ສະແດງແຊັດໃນໜ້າຈອງ',
  'Guests open it from a button on your booking page. Turning it off hides the button; your answers are kept.':
    'ແຂກເປີດແຊັດຈາກປຸ່ມໃນໜ້າຈອງ. ການປິດຈະເຊື່ອງປຸ່ມ; ຄຳຕອບຂອງທ່ານຍັງຖືກເກັບໄວ້.',
  'Assistant name': 'ຊື່ຜູ້ຊ່ວຍ',
  'WhatsApp number': 'ເບີ WhatsApp',
  'International format, e.g. +8562055551234. Guests get a WhatsApp button.':
    'ຮູບແບບສາກົນ ເຊັ່ນ +8562055551234. ແຂກຈະເຫັນປຸ່ມ WhatsApp.',
  'Leave empty for the default welcome in the guest’s language.':
    'ປ່ອຍຫວ່າງໄວ້ເພື່ອໃຊ້ຂໍ້ຄວາມຕ້ອນຮັບມາດຕະຖານຕາມພາສາຂອງແຂກ.',
  'Let AI answer the remaining questions': 'ໃຫ້ AI ຕອບຄຳຖາມທີ່ເຫຼືອ',
  'Only questions your rates, answers and hotel facts cannot cover. Contact details are removed first, guests see that the answer is AI-generated, and AI never quotes prices or confirms bookings.':
    'ສະເພາະຄຳຖາມທີ່ລາຄາ, ຄຳຕອບ ແລະ ຂໍ້ມູນໂຮງແຮມຂອງທ່ານຕອບບໍ່ໄດ້. ຂໍ້ມູນຕິດຕໍ່ຖືກລຶບອອກກ່ອນ, ແຂກຈະເຫັນວ່າຄຳຕອບມາຈາກ AI, ແລະ AI ບໍ່ເຄີຍບອກລາຄາ ຫຼື ຢືນຢັນການຈອງ.',
  'AI model': 'ໂມເດວ AI',
  'paused after errors, retrying shortly': 'ຢຸດຊົ່ວຄາວຫຼັງເກີດຂໍ້ຜິດພາດ, ຈະລອງໃໝ່ໃນບໍ່ຊ້າ',
  tokens: 'ໂທເຄັນ',
  'No AI model is configured on this server. Guests get your team’s contact details instead.':
    'ເຊີບເວີນີ້ຍັງບໍ່ໄດ້ຕັ້ງຄ່າໂມເດວ AI. ແຂກຈະໄດ້ຮັບຂໍ້ມູນຕິດຕໍ່ພະນັກງານແທນ.',
  'An administrator connects a model with HOTEL_CHAT_AI_URL and HOTEL_CHAT_AI_MODEL (any OpenAI-compatible API, such as Qwen, Gemini or a self-hosted model).':
    'ຜູ້ດູແລລະບົບເຊື່ອມຕໍ່ໂມເດວດ້ວຍ HOTEL_CHAT_AI_URL ແລະ HOTEL_CHAT_AI_MODEL (API ທີ່ເຂົ້າກັນໄດ້ກັບ OpenAI ເຊັ່ນ Qwen, Gemini ຫຼື ໂມເດວທີ່ຕິດຕັ້ງເອງ).',
  answer: 'ຄຳຕອບ',
  answers: 'ຄຳຕອບ',
  'in your knowledge base': 'ໃນຖານຄວາມຮູ້ຂອງທ່ານ',
  'How guests are answered': 'ແຂກໄດ້ຮັບຄຳຕອບແນວໃດ',
  'guest messages, 30 days': 'ຂໍ້ຄວາມແຂກ, 30 ມື້',
  'answered without AI': 'ຕອບໂດຍບໍ່ໃຊ້ AI',
  'AI tokens': 'ໂທເຄັນ AI',
  'guest ratings': 'ຄະແນນຈາກແຂກ',
  'Each message stops at the first step that can answer it, so most never need AI.':
    'ແຕ່ລະຂໍ້ຄວາມຢຸດຢູ່ຂັ້ນຕອນທຳອິດທີ່ຕອບໄດ້, ດັ່ງນັ້ນສ່ວນຫຼາຍບໍ່ຈຳເປັນຕ້ອງໃຊ້ AI.',
  'Messages in the last 30 days': 'ຂໍ້ຄວາມໃນ 30 ມື້ຜ່ານມາ',
  'Live availability and prices': 'ຫ້ອງຫວ່າງ ແລະ ລາຄາແບບສົດ',
  'Your rooms, rates and restrictions, exactly as the booking page quotes them':
    'ຫ້ອງ, ລາຄາ ແລະ ຂໍ້ຈຳກັດຂອງທ່ານ ຄືກັບໜ້າຈອງທຸກຢ່າງ',
  'Your answers': 'ຄຳຕອບຂອງທ່ານ',
  'Hotel facts': 'ຂໍ້ມູນໂຮງແຮມ',
  'Check-in times, address, extras, cancellation, payment and your property content':
    'ເວລາເຊັກອິນ, ທີ່ຢູ່, ບໍລິການເສີມ, ການຍົກເລີກ, ການຊຳລະເງິນ ແລະ ຂໍ້ມູນທີ່ພັກຂອງທ່ານ',
  'AI fallback': 'AI ສຳຮອງ',
  'Grounded in the steps above; optional': 'ອີງໃສ່ຂໍ້ມູນຂັ້ນຕອນຂ້າງເທິງ; ບໍ່ບັງຄັບ',
  'Your team': 'ທີມງານຂອງທ່ານ',
  'Phone, WhatsApp and email. Staff confirm bookings in the PMS':
    'ໂທລະສັບ, WhatsApp ແລະ ອີເມລ. ພະນັກງານຢືນຢັນການຈອງໃນ PMS',
  'Knowledge base': 'ຖານຄວາມຮູ້',
  'Verified answers in your words. Updating an answer takes effect immediately; no retraining.':
    'ຄຳຕອບທີ່ຢືນຢັນແລ້ວໃນຄຳເວົ້າຂອງທ່ານ. ການແກ້ໄຂມີຜົນທັນທີ; ບໍ່ຕ້ອງຝຶກ AI ໃໝ່.',
  'Add answer': 'ເພີ່ມຄຳຕອບ',
  'Search answers': 'ຄົ້ນຫາຄຳຕອບ',
  'Start with the questions guests ask most. Tap one to write its answer:':
    'ເລີ່ມຈາກຄຳຖາມທີ່ແຂກຖາມເລື້ອຍທີ່ສຸດ. ແຕະເພື່ອຂຽນຄຳຕອບ:',
  'Is breakfast included?': 'ລວມອາຫານເຊົ້າບໍ?',
  'Do you offer airport pickup?': 'ມີບໍລິການຮັບສົ່ງສະໜາມບິນບໍ?',
  'Is there parking?': 'ມີບ່ອນຈອດລົດບໍ?',
  'Can I check in early or check out late?': 'ເຊັກອິນກ່ອນ ຫຼື ເຊັກເອົ້າຊ້າໄດ້ບໍ?',
  'Do you have Wi-Fi?': 'ມີໄວໄຟບໍ?',
  'Which payment methods do you accept?': 'ຮັບຊຳລະເງິນແບບໃດແດ່?',
  'Guest question': 'ຄຳຖາມຂອງແຂກ',
  'e.g. Is breakfast included?': 'ເຊັ່ນ: ລວມອາຫານເຊົ້າບໍ?',
  'Your answer': 'ຄຳຕອບຂອງທ່ານ',
  'Write the answer once; the assistant reuses it for every guest.':
    'ຂຽນຄຳຕອບຄັ້ງດຽວ; ຜູ້ຊ່ວຍຈະໃຊ້ຕອບແຂກທຸກຄົນ.',
  Keywords: 'ຄຳສຳຄັນ',
  'Words guests might use, in any language, separated by commas.':
    'ຄຳທີ່ແຂກອາດໃຊ້ ເປັນພາສາໃດກໍໄດ້, ຂັ້ນດ້ວຍເຄື່ອງໝາຍ (,).',
  'All languages': 'ທຸກພາສາ',
  'Use this answer in the chat': 'ໃຊ້ຄຳຕອບນີ້ໃນແຊັດ',
  'Save answer': 'ບັນທຶກຄຳຕອບ',
  'Answer saved': 'ບັນທຶກຄຳຕອບແລ້ວ',
  'Answer removed': 'ລຶບຄຳຕອບແລ້ວ',
  'Someone changed this answer. Close it and open it again.':
    'ມີຄົນແກ້ໄຂຄຳຕອບນີ້ແລ້ວ. ປິດ ແລະ ເປີດໃໝ່ອີກຄັ້ງ.',
  'Not in use': 'ບໍ່ໄດ້ໃຊ້',
  Used: 'ໃຊ້ແລ້ວ',
  Keep: 'ເກັບໄວ້',
  'No answers match your search.': 'ບໍ່ພົບຄຳຕອບທີ່ກົງກັບການຄົ້ນຫາ.',
  'Questions to review': 'ຄຳຖາມທີ່ຕ້ອງກວດ',
  'Questions the assistant could not answer from your data, answered with AI, or rated unhelpful. Add an answer once and every future guest gets it instantly.':
    'ຄຳຖາມທີ່ຜູ້ຊ່ວຍຕອບຈາກຂໍ້ມູນຂອງທ່ານບໍ່ໄດ້, ຕອບໂດຍ AI ຫຼື ຖືກໃຫ້ຄະແນນວ່າບໍ່ມີປະໂຫຍດ. ເພີ່ມຄຳຕອບຄັ້ງດຽວ ແລະ ແຂກຕໍ່ໄປຈະໄດ້ຮັບທັນທີ.',
  'Rated unhelpful': 'ຖືກໃຫ້ຄະແນນບໍ່ມີປະໂຫຍດ',
  'Answered by AI': 'ຕອບໂດຍ AI',
  'Not answered': 'ບໍ່ໄດ້ຕອບ',
  'Test the assistant': 'ທົດສອບຜູ້ຊ່ວຍ',
  'Ask what a guest would. Uses your unsaved settings and live rates; nothing is logged.':
    'ຖາມຄືກັບແຂກ. ໃຊ້ການຕັ້ງຄ່າທີ່ຍັງບໍ່ບັນທຶກ ແລະ ລາຄາປັດຈຸບັນ; ບໍ່ມີການບັນທຶກປະຫວັດ.',
  'e.g. Do you have a room for 2 next Friday? / ມີຫ້ອງຫວ່າງບໍ?':
    'ເຊັ່ນ: ມີຫ້ອງຫວ່າງສຳລັບ 2 ຄົນ ວັນສຸກໜ້າບໍ?',
  'Test message': 'ຂໍ້ຄວາມທົດສອບ',
  Test: 'ທົດສອບ',
  'Testing…': 'ກຳລັງທົດສອບ…',
  'Answered by': 'ຕອບໂດຍ',
  Understood: 'ເຂົ້າໃຈວ່າ',
  'Closest answers': 'ຄຳຕອບທີ່ໃກ້ຄຽງທີ່ສຸດ',
  'Live availability': 'ຫ້ອງຫວ່າງແບບສົດ',
  'Asked for dates': 'ຖາມວັນທີ',
  Greeting: 'ທັກທາຍ',
  'Small talk': 'ລົມທົ່ວໄປ',
  'Handed to your team': 'ສົ່ງຕໍ່ໃຫ້ທີມງານ',
  'AI answer': 'ຄຳຕອບ AI',
  'Not answered: contact details shown': 'ບໍ່ໄດ້ຕອບ: ສະແດງຂໍ້ມູນຕິດຕໍ່',
  Thanks: 'ຂອບໃຈ',
  Goodbye: 'ລາກ່ອນ',
  Availability: 'ຫ້ອງຫວ່າງ',
  Booking: 'ການຈອງ',
  Location: 'ທີ່ຕັ້ງ',
  Cancellation: 'ການຍົກເລີກ',
  Extras: 'ບໍລິການເສີມ',
  // Chat assistant audit, 14 October 2026
  'Every other language already has its own text.': 'ທຸກພາສາອື່ນມີຂໍ້ຄວາມຂອງຕົນເອງແລ້ວ.',
  'answered by the assistant': 'ຜູ້ຊ່ວຍຕອບເອງ',
  'with AI': 'ດ້ວຍ AI',
  'not answered, sent to your team': 'ຕອບບໍ່ໄດ້, ສົ່ງໃຫ້ທີມງານ',
  'median reply time': 'ເວລາຕອບກາງ',
  'bookings from chat offers': 'ການຈອງຈາກຂໍ້ສະເໜີໃນແຊັດ',
  'First reply': 'ຕອບຄັ້ງທຳອິດ',
  'waiting for a reply': 'ລໍຖ້າການຕອບ',
  'AI replies': 'ຄຳຕອບຈາກ AI',
  'Questions to answer': 'ຄຳຖາມທີ່ຕ້ອງຕອບ',
  'What the assistant could not answer from your data, answered with AI, or guests rated unhelpful. Answer once and every future guest gets it instantly.':
    'ຄຳຖາມທີ່ຜູ້ຊ່ວຍຕອບຈາກຂໍ້ມູນຂອງທ່ານບໍ່ໄດ້, ທີ່ AI ຕອບ ຫຼື ທີ່ແຂກໃຫ້ຄະແນນວ່າບໍ່ມີປະໂຫຍດ. ຕອບຄັ້ງດຽວ ແລະ ແຂກທຸກຄົນຕໍ່ໄປຈະໄດ້ຮັບຄຳຕອບທັນທີ.',
  'Nothing to review. New questions the assistant cannot answer appear here.':
    'ບໍ່ມີຫຍັງຕ້ອງກວດ. ຄຳຖາມໃໝ່ທີ່ຜູ້ຊ່ວຍຕອບບໍ່ໄດ້ຈະສະແດງຢູ່ນີ້.',
  'Times guests asked this': 'ຈຳນວນເທື່ອທີ່ແຂກຖາມ',
  'AI answer held back': 'ຢຸດຄຳຕອບ AI ໄວ້',
  'Check and save': 'ກວດ ແລະ ບັນທຶກ',
  'Write answer': 'ຂຽນຄຳຕອບ',
  'Grounded in the steps above; answers it cannot back with your data go to your team':
    'ອີງໃສ່ຂັ້ນຕອນຂ້າງເທິງ; ຄຳຕອບທີ່ຂໍ້ມູນຂອງທ່ານບໍ່ຮອງຮັບຈະສົ່ງໃຫ້ທີມງານ',
  'Check-in times, address, rooms, offers, extras, policies and your property content':
    'ເວລາເຊັກອິນ, ທີ່ຢູ່, ຫ້ອງພັກ, ໂປຣໂມຊັ່ນ, ບໍລິການເສີມ, ນະໂຍບາຍ ແລະ ຂໍ້ມູນທີ່ພັກຂອງທ່ານ',
  'Phone, WhatsApp and the guest inbox. Staff confirm bookings in the PMS':
    'ໂທລະສັບ, WhatsApp ແລະ ກ່ອງຂໍ້ຄວາມແຂກ. ພະນັກງານຢືນຢັນການຈອງໃນ PMS',
  Answers: 'ຄຳຕອບ',
  Languages: 'ພາສາ',
  Translated: 'ແປແລ້ວ',
  'Verified answers in your words, in each guest language. A change takes effect immediately; no retraining.':
    'ຄຳຕອບທີ່ກວດແລ້ວດ້ວຍຄຳເວົ້າຂອງທ່ານ, ໃນແຕ່ລະພາສາຂອງແຂກ. ການປ່ຽນແປງມີຜົນທັນທີ; ບໍ່ຕ້ອງຝຶກໃໝ່.',
  Drafted: 'ຮ່າງແລ້ວ',
  'Check them before saving.': 'ກະລຸນາກວດກ່ອນບັນທຶກ.',
  'Show to': 'ສະແດງໃຫ້',
  'Guests in every language': 'ແຂກທຸກພາສາ',
  'Only guests writing': 'ສະເພາະແຂກທີ່ຂຽນ',
  'Suggest keywords from the question': 'ແນະນຳຄຳສຳຄັນຈາກຄຳຖາມ',
  'The answer in each guest language': 'ຄຳຕອບໃນແຕ່ລະພາສາຂອງແຂກ',
  'Draft missing with AI': 'ໃຫ້ AI ຮ່າງພາສາທີ່ຍັງຂາດ',
  'Drafting…': 'ກຳລັງຮ່າງ…',
  'Connect an AI model to draft translations': 'ເຊື່ອມຕໍ່ໂມເດວ AI ເພື່ອຮ່າງຄຳແປ',
  'Question in': 'ຄຳຖາມເປັນ',
  'Optional. Helps guests writing this language find the answer.':
    'ບໍ່ບັງຄັບ. ຊ່ວຍໃຫ້ແຂກທີ່ຂຽນພາສານີ້ຊອກພົບຄຳຕອບ.',
  'Answer in': 'ຄຳຕອບເປັນ',
  'Empty: guests writing this language read the answer above.':
    'ປ່ອຍຫວ່າງ: ແຂກທີ່ຂຽນພາສານີ້ຈະອ່ານຄຳຕອບຂ້າງເທິງ.',
  'Guests read the answer in the language they write. Without a translation they read the answer above.':
    'ແຂກອ່ານຄຳຕອບເປັນພາສາທີ່ເຂົາເຈົ້າຂຽນ. ຖ້າບໍ່ມີຄຳແປ ເຂົາເຈົ້າຈະອ່ານຄຳຕອບຂ້າງເທິງ.',
  'On your booking page': 'ໃນໜ້າຈອງຂອງທ່ານ',
  'Guests see it next to each answer.': 'ແຂກເຫັນຊື່ນີ້ຂ້າງແຕ່ລະຄຳຕອບ.',
  'AI for the remaining questions': 'AI ສຳລັບຄຳຖາມທີ່ເຫຼືອ',
  'Only questions your rates, answers and hotel facts cannot cover. Contact details are removed first, guests see that the answer is AI-generated, and an answer stating a price, time or contact your data does not contain goes to your team instead.':
    'ສະເພາະຄຳຖາມທີ່ລາຄາ, ຄຳຕອບ ແລະ ຂໍ້ມູນໂຮງແຮມຂອງທ່ານຕອບບໍ່ໄດ້. ຂໍ້ມູນຕິດຕໍ່ຖືກລຶບອອກກ່ອນ, ແຂກເຫັນວ່າຄຳຕອບມາຈາກ AI, ແລະ ຄຳຕອບທີ່ບອກລາຄາ, ເວລາ ຫຼື ຂໍ້ມູນຕິດຕໍ່ທີ່ບໍ່ມີໃນຂໍ້ມູນຂອງທ່ານຈະຖືກສົ່ງໃຫ້ທີມງານແທນ.',
  'No AI model is connected. Guests get your answers and your team’s contact details. Ask your LFB administrator to connect one.':
    'ຍັງບໍ່ໄດ້ເຊື່ອມຕໍ່ໂມເດວ AI. ແຂກຈະໄດ້ຮັບຄຳຕອບຂອງທ່ານ ແລະ ຂໍ້ມູນຕິດຕໍ່ທີມງານ. ກະລຸນາຂໍໃຫ້ຜູ້ດູແລລະບົບ LFB ເຊື່ອມຕໍ່.',
  Welcome: 'ຂໍ້ຄວາມຕ້ອນຮັບ',
  'The first message and buttons guests see. Write them once for all languages, then adjust each language if you like.':
    'ຂໍ້ຄວາມທຳອິດ ແລະ ປຸ່ມທີ່ແຂກເຫັນ. ຂຽນຄັ້ງດຽວສຳລັບທຸກພາສາ, ແລ້ວປັບແຕ່ລະພາສາຕາມຕ້ອງການ.',
  'Draft translations with AI': 'ໃຫ້ AI ຮ່າງຄຳແປ',
  'Guest language': 'ພາສາຂອງແຂກ',
  'Leave empty to use the message for all languages.': 'ປ່ອຍຫວ່າງເພື່ອໃຊ້ຂໍ້ຄວາມສຳລັບທຸກພາສາ.',
  'Default welcome in this language': 'ຂໍ້ຄວາມຕ້ອນຮັບເລີ່ມຕົ້ນໃນພາສານີ້',
  'Guests can always type a message.': 'ແຂກພິມຂໍ້ຄວາມໄດ້ສະເໝີ.',
  'Same as all languages': 'ຄືກັບທຸກພາສາ',
  'No choices': 'ບໍ່ມີຕົວເລືອກ',
  'Up to 6 choices. Custom text is shown as written.':
    'ສູງສຸດ 6 ຕົວເລືອກ. ຂໍ້ຄວາມທີ່ກຳນົດເອງຈະສະແດງຕາມທີ່ຂຽນ.',
  'Team replies': 'ທີມງານຕອບ',
  'Tell guests when your team replies': 'ບອກແຂກວ່າທີມງານຕອບເວລາໃດ',
  'The assistant answers around the clock. Guests handed to your team outside these hours are told when you are back.':
    'ຜູ້ຊ່ວຍຕອບໄດ້ຕະຫຼອດ 24 ຊົ່ວໂມງ. ແຂກທີ່ຖືກສົ່ງໃຫ້ທີມງານນອກເວລາເຫຼົ່ານີ້ຈະໄດ້ຮູ້ວ່າທີມງານຈະກັບມາເມື່ອໃດ.',
  Sunday: 'ວັນອາທິດ',
  Monday: 'ວັນຈັນ',
  Tuesday: 'ວັນອັງຄານ',
  Wednesday: 'ວັນພຸດ',
  Thursday: 'ວັນພະຫັດ',
  Friday: 'ວັນສຸກ',
  Saturday: 'ວັນເສົາ',
  'All day': 'ທັງມື້',
  'No replies': 'ບໍ່ຕອບ',
  'Same start and end time means all day. An end before the start runs past midnight.':
    'ເວລາເລີ່ມ ແລະ ສິ້ນສຸດຄືກັນໝາຍເຖິງທັງມື້. ເວລາສິ້ນສຸດກ່ອນເວລາເລີ່ມໝາຍເຖິງຂ້າມທ່ຽງຄືນ.',
  'Typical first reply': 'ເວລາຕອບຄັ້ງທຳອິດໂດຍທົ່ວໄປ',
  'Guests handed to your team during opening hours are told to expect a reply within this time.':
    'ແຂກທີ່ຖືກສົ່ງໃຫ້ທີມງານໃນເວລາເຮັດວຽກຈະໄດ້ຮູ້ວ່າຈະໄດ້ຮັບຄຳຕອບພາຍໃນເວລານີ້.',
  'Don’t tell guests': 'ບໍ່ບອກແຂກ',
  minutes: 'ນາທີ',
  'On your website': 'ໃນເວັບໄຊຂອງທ່ານ',
  'Paste this code before the closing </body> tag of your website, or in a custom code block of your website builder. It adds a chat button that opens your assistant.':
    'ວາງໂຄດນີ້ກ່ອນແທັກ </body> ຂອງເວັບໄຊທ່ານ ຫຼື ໃນບລັອກໂຄດຂອງເຄື່ອງມືສ້າງເວັບ. ມັນຈະເພີ່ມປຸ່ມແຊັດທີ່ເປີດຜູ້ຊ່ວຍຂອງທ່ານ.',
  'Publish your booking page to get the website code.': 'ເຜີຍແຜ່ໜ້າຈອງເພື່ອຮັບໂຄດສຳລັບເວັບໄຊ.',
  'Turn on the chat above to get the website code.': 'ເປີດແຊັດຂ້າງເທິງເພື່ອຮັບໂຄດສຳລັບເວັບໄຊ.',
  'Button text': 'ຂໍ້ຄວາມເທິງປຸ່ມ',
  'shown in your booking page color': 'ສະແດງດ້ວຍສີຂອງໜ້າຈອງ',
  'Website code': 'ໂຄດສຳລັບເວັບໄຊ',
  'Code copied': 'ສຳເນົາໂຄດແລ້ວ',
  'Select the code and copy it': 'ເລືອກໂຄດແລ້ວສຳເນົາ',
  'Copy code': 'ສຳເນົາໂຄດ',
  'Open booking engine': 'ເປີດລະບົບຈອງ',
  'Guest inbox': 'ກ່ອງຂໍ້ຄວາມແຂກ',
  'Handed to your team and waiting for a reply': 'ສົ່ງໃຫ້ທີມງານແລ້ວ ແລະ ລໍຖ້າການຕອບ',
  'Booking page not published': 'ໜ້າຈອງຍັງບໍ່ເຜີຍແຜ່',
  'Publish your booking page to give guests the chat.': 'ເຜີຍແຜ່ໜ້າຈອງເພື່ອໃຫ້ແຂກໃຊ້ແຊັດໄດ້.',
  'Chat is turned off': 'ປິດແຊັດຢູ່',
  'Guests do not see it. Turn it on in Settings.': 'ແຂກບໍ່ເຫັນແຊັດ. ເປີດໄດ້ໃນການຕັ້ງຄ່າ.',
  'Live for guests': 'ແຂກໃຊ້ໄດ້ແລ້ວ',
  'On your booking page and chat link · your team is replying now':
    'ໃນໜ້າຈອງ ແລະ ລິ້ງແຊັດ · ທີມງານກຳລັງຕອບຢູ່',
  'On your booking page and chat link · the assistant answers while your team is away':
    'ໃນໜ້າຈອງ ແລະ ລິ້ງແຊັດ · ຜູ້ຊ່ວຍຕອບແທນໃນເວລາທີມງານບໍ່ຢູ່',
  'On your booking page and your chat link': 'ໃນໜ້າຈອງ ແລະ ລິ້ງແຊັດຂອງທ່ານ',
  'Chat link': 'ລິ້ງແຊັດ',
  tomorrow: 'ມື້ອື່ນ',
  'Team away': 'ທີມງານບໍ່ຢູ່',
  'Preview conversation': 'ຕົວຢ່າງການສົນທະນາ',
  'The chat is turned off, so guests do not see it. You can still try it here.':
    'ແຊັດປິດຢູ່ ແຂກຈຶ່ງບໍ່ເຫັນ. ທ່ານຍັງທົດລອງໄດ້ຢູ່ນີ້.',
  left: 'ເຫຼືອ',
  'From your answer': 'ຈາກຄຳຕອບຂອງທ່ານ',
  'Ask what a guest would…': 'ຖາມຄືກັບແຂກ…',
  'Uses your unsaved settings and live rates. Nothing is logged; AI replies use tokens.':
    'ໃຊ້ການຕັ້ງຄ່າທີ່ຍັງບໍ່ບັນທຶກ ແລະ ລາຄາປັດຈຸບັນ. ບໍ່ມີການບັນທຶກ; ຄຳຕອບ AI ໃຊ້ໂທເຄັນ.',
  'Why this answer': 'ເປັນຫຍັງຈຶ່ງຕອບແບບນີ້',
  'AI answer held back: your data does not mention': 'ຢຸດຄຳຕອບ AI ໄວ້: ຂໍ້ມູນຂອງທ່ານບໍ່ໄດ້ກ່າວເຖິງ',
  'Not answered: sent to your team': 'ຕອບບໍ່ໄດ້: ສົ່ງໃຫ້ທີມງານ',
  'Hotel or assistant name': 'ຊື່ໂຮງແຮມ ຫຼື ຜູ້ຊ່ວຍ',
  'Number of rooms': 'ຈຳນວນຫ້ອງ',
  Offers: 'ໂປຣໂມຊັ່ນ',
  'Not about the stay': 'ບໍ່ກ່ຽວກັບການພັກ',
  'Our team replies': 'ທີມງານຕອບ',
  'Our team is away': 'ທີມງານບໍ່ຢູ່',
  'Chatting as a guest': 'ແຊັດໃນນາມແຂກ',
  'Add your name': 'ເພີ່ມຊື່ຂອງທ່ານ',
  'So our team can reply to you personally, add your name. A WhatsApp number lets them follow up if you leave.':
    'ເພື່ອໃຫ້ທີມງານຕອບທ່ານໄດ້ໂດຍກົງ, ກະລຸນາເພີ່ມຊື່. ເບີ WhatsApp ຊ່ວຍໃຫ້ທີມງານຕິດຕໍ່ກັບໄດ້ຖ້າທ່ານອອກຈາກແຊັດ.',
  'Add contact details': 'ເພີ່ມຂໍ້ມູນຕິດຕໍ່',
};
